

































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Modal from '@/components/Modal.vue'
import Input from '@/components/inputs/Input.vue'
import { validateEmail } from '@/utils/helpers'
import { ResidentModule } from '@/store/modules/resident.module'
import { IResidentEventHistoryFiltersDTO, ICreateResidentUserWithTempPasswordDTO, isObj } from '@zunta/configurations'
import Password from '@/components/inputs/Password.vue'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  props: {
    residentId: {
      type: [String, Number],
      required: true
    },
    facilityId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    Icon,
    Password,
    Input,
    Modal,
    ErrorMessages,
    ModalV2,
  }
})
export default class PortalInvitationPopup extends Vue {
  email: string = ''
  firstName: string = ''
  lastName: string = ''
  isSending: boolean = false
  errors: string[] = []
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  residentHistoryFilters: IResidentEventHistoryFiltersDTO = {}
  isCreatingWithTempPassword: boolean = false
  password: string = ''
  showConfirmationPopup = false
  isObj = isObj

  validate () {
    this.errors = []
    if (!validateEmail(this.email)) {
      this.errors.push('Incorrect email')
    }
    if (!this.firstName) {
      this.errors.push('Incorrect first name')
    }
    if (!this.lastName) {
      this.errors.push('Incorrect last name')
    }
    if (this.isCreatingWithTempPassword && !this.password) {
      this.errors.push('Password is empty')
    }
    return this.errors.length === 0
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  validateAndPromptConfirmation () {
    if (!this.validate()) {
      return
    }
    this.showConfirmationPopup = true
  }

  async send () {
    this.isSending = true
    const data: ICreateResidentUserWithTempPasswordDTO | any = {
      residentId: this.$props.residentId,
      facilityId: this.$props.facilityId,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName
    }

    let response
    if (this.isCreatingWithTempPassword) {
      data.password = this.password
      const user = Api.getUser()
      if (user) {
        data.user = user.data
      }
      response = await this.residentModuleInstance.createResidentUserWithInvitation(data)
    } else {
      response = await this.residentModuleInstance.sendInvitationToResidentPortal(data)
    }

    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        header: 'Send Invitation',
        message: 'Invitation Successfully Sent',
        icon: 'check'
      })
      await this.residentModuleInstance.fetchResidentHistoryByFilters({
        residentId: this.$props.residentId,
        filters: this.residentHistoryFilters
      })
      this.$emit('close')
      this.showConfirmationPopup = false
      return
    }

    this.errors = []
    this.errors.push(response.message)

    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      header: 'Send Invitation',
      message: response.message ? response.message : 'Something went wrong',
      icon: 'warning'
    })
    this.isSending = false
  }

  toggleCreatePasswordField (value: boolean): void {
    this.isCreatingWithTempPassword = value
  }
}
